import NextLink from 'next/link'
import { useRouter } from 'next/router'
import { AnchorHTMLAttributes, forwardRef, VFC } from 'react'
import { fontWeightRegular } from 'src/styles/font'
import { isClientPath, SORRY } from 'src/utils/routes'
import styled, { css } from 'styled-components'

export type LinkProps = Omit<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  'href'
> & {
  href: string
}
export const Link: VFC<LinkProps> = ({ href, children, ...props }) => {
  const { pathname } = useRouter()
  return pathname !== SORRY && isClientPath(href) ? (
    <NextLink href={href} passHref>
      <NoBasePathLink {...props}>{children}</NoBasePathLink>
    </NextLink>
  ) : (
    <a
      href={href}
      target={href?.startsWith('/') ? undefined : '_blank'}
      rel="noreferrer"
      {...props}
    >
      {children}
    </a>
  )
}

export const ButtonLink = styled(Link)<{ background?: string; color?: string }>`
  border-radius: 20px;
  padding: 6px 12px;

  font-size: 14px;
  font-weight: ${fontWeightRegular};
  line-height: 1.4;
  text-align: center;
  white-space: nowrap;
  ${({ background, color }) => css`
    ${background && `background: ${background}`};
    ${color && `color: ${color}`};
  `}
`

const NoBasePathLink = forwardRef<
  HTMLAnchorElement,
  AnchorHTMLAttributes<HTMLAnchorElement>
>(({ href, children, ...props }, ref) => (
  <a {...props} ref={ref} href={href}>
    {children}
  </a>
))
